import { gql as t } from "@apollo/client";
t`
  fragment Owner on Account {
    avatar
    name
    tag
    walletAddress
    createdAt
  }
`;
const e = t`
  fragment PublicOwner on PublicAccount {
    avatar
    name
    tag
    walletAddress
    createdAt
  }
`;
export {
  e as PublicOwnerFragment
};
//# sourceMappingURL=account.js.map
